import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const getAllFiles = async () => {
  const config = {
    url: `${apiServerUrl}/file`,
    method: "GET",

    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });
  return {
    data: data.data || null,
    error,
  };
};

export const uploadFile = async (accessToken, formData) => {
  const config = {
    method: "post",
    url: `${apiServerUrl}/file`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: formData,
  };

  return await callExternalApi({ config });
};

export const deleteFile = async (accessToken, fileId) => {
  const config = {
    method: "delete",
    url: `${apiServerUrl}/file/${fileId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return await callExternalApi({ config });
};
